import AssessmentSubScore from "./assessmentSubScore";
import AssessmentSummaryDetails from "../assessment/score/assessmentSummaryDetails";


function AssessmentBody(props) {

  // Define variables
  const summary = props.summary;
  const assessment = props.assessment;
  const scorePronunciation = assessment.scorePronunciation;
  const scoreGrammar = assessment.scoreGrammar;
  const scoreFluency = assessment.scoreFluency;
  const scoreVocabulary = assessment.scoreVocabulary;
  const scoreRelevance = assessment.scoreRelevance;


  // Screen components
  let summayElement;
  if( summary ) {
    summayElement = (
      <div class='flex-column my-assessment-body'>
        <p class='my-assess-cefr-label'>Summary</p>
        <div class='my-assessment-summary'>
          <AssessmentSummaryDetails summary={summary} />
        </div>
      </div>
    );
  }


  return (
    <>
      <div class='flex-column my-assessment-body'>
        <div class='my-assessment-body-inner'>
          <AssessmentSubScore title={'Fluency'} score={scoreFluency} />
          <AssessmentSubScore title={'Relevance'} score={scoreRelevance} />
          <AssessmentSubScore title={'Pronunciation'} score={scorePronunciation} />
          <AssessmentSubScore title={'Grammar'} score={scoreGrammar} />
          <AssessmentSubScore title={'Vocabulary'} score={scoreVocabulary} />
        </div>
      </div>
      {summayElement}
    </>
  );
}

export default AssessmentBody;